import { DefaultResponseWithData } from "../system";
import { PartRequestMatchStrength, PartRequestSource, PartRequestStatus } from "../partRequests/IPartRequest";

// Wire values are ints - keep in sync with GPMetals.Core/Entities/StockSearch.cs
export enum StockSearchSource {
  Filters = 0,
  SmartMatch = 1,
}

/** POST /stocksearch - what the Stock page sends when a search is made. */
export interface IRecordStockSearch {
  source: StockSearchSource;
  vrm?: string | null;
  make?: string | null;
  model?: string | null;
  yearFrom?: number | null;
  yearTo?: number | null;
  engineCode?: string | null;
  categoryIds?: string[];
}

export interface IStockSearch {
  id: string;
  source: StockSearchSource;
  vrm: string | null;
  make: string | null;
  model: string | null;
  yearFrom: number | null;
  yearTo: number | null;
  mark: number | null;
  engineCode: string | null;
  categoryIds: string[];
  created: string;
  lastSearchedOn: string;
  repeats: number;
}

export interface IStockSearchResponse extends DefaultResponseWithData<IStockSearch> {}

export interface IVehicleDemandCategory {
  partCategoryId: string;
  searches: number;
  partRequests: number;
}

export interface IVehicleDemandPartRequest {
  id: string;
  partWanted: string;
  partCategoryId: string | null;
  partCategoryName: string | null;
  customerName: string | null;
  source: PartRequestSource;
  status: PartRequestStatus;
  strength: PartRequestMatchStrength;
  requestedAt: string;
  vrm: string | null;
  make: string | null;
  model: string | null;
  year: number | null;
}

/** GET /stocksearch/vehicle/{id} - searches and open requests that match one vehicle. */
export interface IVehicleDemand {
  vehicleId: string;
  since: string;
  totalSearches: number;
  byEngineCode: number;
  byMakeModel: number;
  uncategorised: number;
  openPartRequests: number;
  uncategorisedPartRequests: number;
  categories: IVehicleDemandCategory[];
  partRequests: IVehicleDemandPartRequest[];
}

export interface IVehicleDemandResponse extends DefaultResponseWithData<IVehicleDemand> {}
